<template>
	<div class="vuestic-simple-select">
		<div class="form-group with-icon-right dropdown select-form-group" v-dropdown.isBlocked :class="{'has-error': hasErrors()}">
			<div class="input-group dropdown-toggle vuestic-simple-select__dropdown-toggle">
				<div>
					<input @focus="showDropdown()" autocomplete="off" :class="{'has-value': !!value}" v-model="displayValue" :name="name" :options="options">
					<label class="control-label">{{label}}</label><i class="bar"/>
					<small v-show="hasErrors()" class="help text-danger">
						{{ showRequiredError() }}
					</small>
				</div>
				<i class="ion ion-ios-arrow-down icon-right input-icon vuestic-simple-select__dropdown-arrow" @click="showDropdown" />
			</div>
			<div v-if="isClearable">
				<i class="fa fa-close icon-cross icon-right input-icon vuestic-simple-select__unselect" @click="unselectOption" />
			</div>
			<div class="dropdown-menu vuestic-simple-select__dropdown-menu" aria-labelledby="dropdownMenuButton">
        <div class="dropdown-menu-content vuestic-simple-select__dropdown-menu-content">
          <div class="dropdown-item vuestic-simple-select__dropdown-item" :key="index" v-for="(option, index) in filteredList" :class="{'selected': isOptionSelected(option)}" @click="toggleSelection(option)">
            <span class="ellipsis">{{optionKey ? option[optionKey] : option}}</span>
          </div>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
import Dropdown from 'vuestic-directives/Dropdown'
import Scrollbar from '../vuestic-scrollbar/VuesticScrollbar.vue'

import axios from 'axios';

import {
    search
} from '@/services/utils';

export default {
	name: 'vuestic-custom-input-autocomplete',
		components: {
			Scrollbar
		},
		directives: {
			dropdown: Dropdown
		},
		props: {
			label: String,
			value: {
				default: '',
				required: true
			},
			searchKey: {
				type: String,
				default: 'name'
			},
			optionKey: String,
			required: {
				type: Boolean,
				default: false
			},
			api: {
				type: String,
				required: true
			},
			clearable: {
				type: Boolean,
				default: true
			},
			name: {
				type: String,
				default: 'simple-select'
			},
		},
		data() {
			return {
				validated: false,
				displayValue: this.value,
				selectedValue: this.value,
				options: [],
			}
		},
		mounted () {
		},
		watch: {
			value: {
				handler(value) {
					if (this.optionKey) {
						this.selectedValue = value[this.optionKey]
						this.displayValue = value[this.optionKey]
					} else {
						this.displayValue = value || ''
						this.selectedValue = value || ''
					}
				},
				immediate: true,
			},
			displayValue : function(query){
				this.options = [];
				if(query){
					if (query.length > 2) {
							search(this.api, query, this.searchKey)
								.then(response => {
									this.options = response.data;
								})
								.catch( (err) => {
									this.launchToast(err);
								})
					}
				}

			}
		},
		computed: {
			filteredList() {
				const optionKey = this.optionKey
				const displayValue = this.displayValue
				if (displayValue === '') {
					return this.options
				} else {

					try {
						return this.options.filter(function(item) {
							if (optionKey && item[optionKey] || item[optionKey].search(displayValue.toLowerCase()) ) {
								if (displayValue) {
									return item[optionKey];
									// return item[optionKey].toLowerCase().search(displayValue.toLowerCase()) === 0
								}
							} else {
								return item.toLowerCase().search(displayValue.toLowerCase()) === 0
							}
						});
					}
					catch(error) {
						return error;
					}
				}
			},
			isClearable() {
				return (this.clearable && this.selectedValue !== '' && this.displayValue !== '' && this.selectedValue !== undefined)
			},
			placeholder() {
				if (this.optionKey && this.selectedValue) {
					return this.selectedValue[this.optionKey]
				} else {
					return this.selectedValue
				}
			}
		},
		methods: {
			toggleSelection(option) {
				this.isOptionSelected(option) ? this.unselectOption() : this.selectOption(option)
			},
			unselectOption() {
				this.selectedValue = ''
				this.$emit('input', this.selectedValue)
			},
			showDropdown() {
				this.displayValue = ''
			},
			isOptionSelected(option) {
				if (this.optionKey) {
					return this.selectedValue === option[this.optionKey]
				} else {
					return this.selectedValue === option
				}
			},
			selectOption(option) {
				this.displayValue = option
				this.selectedValue = this.displayValue
				this.$emit('input', this.selectedValue)
			},
			validate() {
				this.validated = true
			},
			isValid() {
				let isValid = true
				// console.log('CHECANDO VE SE TEM', this.value.hasOwnProperty(this.optionKey))
				if (this.required) {
					isValid = !!this.value
				}
				return isValid
			},
			hasErrors() {
				let hasErrors = false
				if (this.required) {
					hasErrors = this.validated && !this.value.hasOwnProperty(this.optionKey)
				}
				return hasErrors
			},
			showRequiredError() {
				return `${this.$t('forms.field')} ${this.label} ${this.$t('forms.mandatory')}`
			}
		}
	}
</script>

<style lang="scss">
.vuestic-simple-select {

  &__unselect {
	margin-right: 20px;
	cursor: pointer;
  }

  .vuestic-simple-select__dropdown-arrow.vuestic-simple-select__dropdown-arrow {
	top: 12px;
	cursor: pointer;
  }

  &__dropdown-menu {
	padding: 0;
  max-height: 150px !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important;

	.vuestic-scrollbar {
    max-height: 600px !important;
	}
  }
}
</style>




// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-custom-input-autocomplete/InputAutocomplete.vue